const vizqlId = "X-Session-Id";
const globalHeader = "Global-Session-Header";

export class SessionRoute {
  public readonly vizqlSessionRoute: string;
  public readonly ingressProxySessionHeader: string;

  constructor(vizSession: string, workerNode: string) {
    this.vizqlSessionRoute = vizSession;
    this.ingressProxySessionHeader = workerNode;
  }

  public static FromHeaders(
    responseHeaders: Headers,
    sessionRouteFromStorage: SessionRoute | null
  ) {
    return new SessionRoute(
      responseHeaders.get(vizqlId) || "",
      responseHeaders.get(globalHeader) ||
        sessionRouteFromStorage?.ingressProxySessionHeader ||
        ""
    );
  }
}
